(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvNumberInput', function () {
            
            return  {
                templateUrl: 'app/fieldinput/number-input.tmpl.html',
                require: "ngModel",
                scope: {
                    value: '=ngModel',
                    field: '='
                },
                controller: ['$element', function ($element) {
                    var drvCtrl = this;
                    drvCtrl.showSuffix = showSuffix;
                    drvCtrl.calculateInputWidth = calculateInputWidth;
                    drvCtrl.roundNumber = roundNumber;

                    activate();

                    function activate() {
                    }

                    function calculateInputWidth() {
                        var result = 30;
                        var elementSmallerThanLength = false;



                        if ((!angular.isUndefined(drvCtrl.field.Length) && drvCtrl.field.Length !== null) || (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value.length > 30)) {
                            var length;

                            if (!angular.isUndefined(drvCtrl.field.Length) && drvCtrl.field.Length !== null) {
                                length = drvCtrl.field.Length;
                            }
                            else {
                                length = drvCtrl.value.length;
                            }

                            var pixelNeeded = (length * 12) + 60;
                            if (pixelNeeded > $element[0].firstElementChild.clientWidth) {
                                elementSmallerThanLength = true;
                            }
                            else {
                                result = length + 5;
                            }
                        }

                        if (($element[0].firstElementChild.clientWidth < 380 && (angular.isUndefined(drvCtrl.field.Length) || drvCtrl.field.Length === null)) || elementSmallerThanLength) {
                            result = Math.floor($element[0].firstElementChild.clientWidth / 12) - 5;
                        }

                        return result * 0.7;
                    }

                    function roundNumber() {
                        if (!_.isNil(drvCtrl.value) && !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Decimal)) {
                            var d = drvCtrl.field.Decimal;
                            var m = Math.pow(10, d);
                            var n = +(d ? drvCtrl.value * m : drvCtrl.value).toFixed(8);
                            var i = Math.floor(n), f = n - i;
                            var e = 1e-8;
                            var r = (f > 0.5 - e && f < 0.5 + e) ?
                                        ((i % 2 === 0) ? i : i + 1) : Math.round(n);
                            drvCtrl.value = d ? r / m : r;
                        }
                    }

                    function showSuffix() {
                        return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: function (scope, elem, attr, ctrl) {
                    angular.element(window).on('resize', function () {
                        scope.$apply(function () {
                            scope.drvCtrl.calculateInputWidth();
                        });
                    });

                    angular.element(elem).find('INPUT').bind('blur', scope.drvCtrl.roundNumber);
                }
            };
        });
})();